// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import Flag from '@wix/da-react-context/pkg/flags/Flag';
import ConnectedFlagsProvider from '../redux/flags/ConnectedFlagsProvider';
import 'focus-visible';
const DaAppWrapper = ({ store, children, headTags })=>{
    var _store_getState_flags, _store_getState;
    let content = children;
    const isDebug = (_store_getState = store.getState()) === null || _store_getState === void 0 ? void 0 : (_store_getState_flags = _store_getState.flags) === null || _store_getState_flags === void 0 ? void 0 : _store_getState_flags.hasOwnProperty('redux_selector_debug');
    const reduxStabilityCheck = isDebug ? 'always' : 'never';
    if (process.env.NODE_ENV !== 'production') {
        content = /*#__PURE__*/ React.createElement(Flag, {
            condition: "strictmode",
            render: ()=>/*#__PURE__*/ React.createElement(React.StrictMode, null, children),
            fallbackRender: ()=>/*#__PURE__*/ React.createElement(React.Fragment, null, children)
        });
    }
    return /*#__PURE__*/ React.createElement(HelmetProvider, {
        context: headTags
    }, /*#__PURE__*/ React.createElement(Provider, {
        store: store,
        stabilityCheck: reduxStabilityCheck
    }, /*#__PURE__*/ React.createElement(ConnectedFlagsProvider, null, content)));
};
DaAppWrapper.displayName = 'DaAppWrapper';
export default DaAppWrapper;
